<template>
    <div id="notes">
        <div id="visitor-notes" v-if="!!this.notes.length">
            <div v-for="note of notes" class="item">
                <div class="name-date">
                    <div class="agent-name">{{ note.createdUser.name }}</div>
                    <div
                        class="date"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$moment(note.createdAt).format('LLL')"
                    >
                        {{ $moment(note.createdAt).fromNow() }}
                    </div>
                </div>
                <div class="agent-note">{{ note.description }}</div>
            </div>
        </div>
        <div class="data-box" v-else>
            <div class="last-session-info">
                <div class="material-icons" style="font-size: 20px">block</div>
                <div class="last-session-data" style="margin-top: 5px">{{ $t("visitor.notUserData") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";

const log = log2("VisitorNotes");

export default {
    name: "VisitorNotes",
    components: {},
    props: {
        notes: {
            type: Array,
            default: [],
        },
    },
    watch: {},
};
</script>

<style lang="scss">
#notes {
    #visitor-notes {
        color: var(--color7) !important;
        display: flex;
        flex-direction: column;
        top: 90px;
        bottom: 30px;
        width: 100%;
        max-height: 386px;
        overflow-y: auto;
        border: 1px solid #dbe1e8;
        border-radius: 4px;

        .name-date {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .last-session-data {
            max-width: 200px;
            color: #516173;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        }

        .data-box {
            border: 1px solid #dbe1e8;
            border-radius: 4px;
            -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
            padding: 25px;
            display: grid;
            width: 100%;
        }

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .item {
            border-bottom: 1px solid #dbe1e8;
            width: 100%;
            padding: 18px 25px;

            .agent-name {
                font-weight: bold;
                font-size: 16px;
            }
        }
    }
}
</style>
